<template lang="pug">
  .progress
    .meter(:style="{ width: `${100 * percent}%`, backgroundColor: backgroundColor }")
</template>

<script>
export default {
  props: [ 'percent', 'color' ],
  methods: {

  },
  computed: {
    backgroundColor () {
      return this.color || '#999999'
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  background-color: #ffffff;
  height: 6px;
  margin: 0;
  border-radius: 0;
  overflow: hidden;

  .meter {
    height: 6px;

  }
}</style>



// WEBPACK FOOTER //
// src/components/buildings/common/ProgressBar.vue